import { render, staticRenderFns } from "./LifePage4.vue?vue&type=template&id=90971b82&scoped=true"
import script from "./LifePage4.vue?vue&type=script&lang=js"
export * from "./LifePage4.vue?vue&type=script&lang=js"
import style0 from "./LifePage4.vue?vue&type=style&index=0&id=90971b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90971b82",
  null
  
)

export default component.exports